export default __webpack_public_path__ + "static/media/AdsAiGen.531ee3b3.png";